import { COLLECTION_ADMINISTRATION_CODES } from "@constants/modules/collectionAdministration/collectionAdministrationCodes"
import FeatureButton from "@tcomponents/FeatureButton/FeatureButton"

export const dropdownCollectionAdministrationItems = ({
    record,
    chargeInstanceId,
    handleRedirectTo,
    onUpdateAmount,
    onExtraordinaryPayment,
    onExonerate
}) => {

    const defaultOptions = [
        record?.status_code === 'paidOff' || record?.status_code === 'settled' ? {
            key: 0,
            label: <FeatureButton
                dropdownItem
                code={COLLECTION_ADMINISTRATION_CODES.COLLECTION_ADMINISTRATION_CHECK_PAYMENT_COMPROBANT}
                popoverProps={{
                    style: { zIndex: 2000 }
                }}
                onClick={() => {
                    return handleRedirectTo(`/administration-collection/received-payments/${chargeInstanceId}/comprobant/${record?.place_id}`)
                }}
            >
                Ver comprobante
            </FeatureButton >,
        } : undefined,
        record?.status_code === 'pending' || record?.status_code === 'overdue' ? {
            key: 0,
            label: <FeatureButton
                dropdownItem
                code={COLLECTION_ADMINISTRATION_CODES.COLLECTION_ADMINISTRATION_CREATE_PAYMENT_EXTRAORDINARY}
                popoverProps={{
                    style: { zIndex: 2000 }
                }}
                onClick={() => {
                    return onExtraordinaryPayment({ record, isOpen: true, name: 'extraordinary_payment' })
                }}
            >
                Pago extraordinario
            </FeatureButton>,
        } : undefined,
        record?.status_code === 'pending' || record?.status_code === 'overdue' ? {
            key: 1,
            label: <FeatureButton
                dropdownItem
                code={COLLECTION_ADMINISTRATION_CODES.COLLECTION_ADMINISTRATION_UPDATE_DEBTOR}
                popoverProps={{
                    style: { zIndex: 2000 }
                }}
                onClick={() => {
                    return onUpdateAmount({ record, isOpen: true, name: 'amount' })
                }}
            >
                Editar monto
            </FeatureButton>,
            action: () => {
            }
        } : undefined,
        record?.status_code === 'pending' || record?.status_code === 'overdue' ? {
            key: 2,
            label: <FeatureButton
                dropdownItem
                code={COLLECTION_ADMINISTRATION_CODES.COLLECTION_ADMINISTRATION_EXONERATE_DEBTOR}
                popoverProps={{
                    style: { zIndex: 2000 }
                }}
                onClick={() => {
                    return onExonerate({ record, isOpen: true, name: 'exonerate' })
                }}
            >
                Exonerar
            </FeatureButton>,
            disabled: record.status_code === 'removed',
        } : undefined
    ].filter((item) => item !== undefined)

    if (defaultOptions.length === 0) {
        defaultOptions.push({
            key: 0,
            label: 'Sin acciones disponibles',
            disabled: true,
            action: () => {

            }
        })
    }


    return defaultOptions
}